import React, { useState, useCallback, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import Button from '../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Checkbox, Input, Select } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createDish, getDishFile, updateDish } from '../../actions/directoryCanteen'
import { GET_DISH_FILE } from '../../actions/types'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.scss'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
})

export default function DishesModal({ data, closeModal, width, height, addMode }) {
  const dispatch = useDispatch()
  const { dishFile, dishTypeList } = useSelector(state => state.directoryCanteen)

  const [confirmation, setConfirmation] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const [image, setImage] = useState(null)
  const [parallels, setParallels] = useState([])

  const isOpen = !!data

  useEffect(() => {
    if (!dishFile) return
    setImage(dishFile)
    addMode && dispatch({ type: GET_DISH_FILE, payload: null })
  }, [dishFile, addMode, dispatch])

  useEffect(() => {
    if (data?.xp_key) {
      dispatch(getDishFile(data.xp_key))
    }
    if (data?.eat_period) {
      setParallels(data.eat_period.map(el => el.eat_period_xp_key))
    }
  }, [data, dispatch])

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setValues,
    dirty,
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode
      ? (vals) => {
        dispatch(createDish(vals, image))
        handleInternalClose()
      }
      : ({ xp_key, ...vals }) => {
        dispatch(updateDish(xp_key, vals, image))
        handleInternalClose()
      }
  })

  useEffect(() => {
    setValues({ ...values, xp_eat_period: parallels })
  }, [parallels])

  useEffect(() => {
    setIsDirty(dirty)
  }, [dirty])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }

  const handleChangeFile = (e) => {
    setImage(Object.values(e.target.files)[0])
  }

  const handleChangeCheck = (e) => {
    if (parallels?.find(el => el === +e.target.value)) {
      setParallels(parallels.filter((el, i) => parallels.indexOf(+e.target.value) !== i))
    } else {
      setParallels((prev) => (prev ? [...prev, +e.target.value] : [+e.target.value]))
    }
  }

  const handleInternalClose = useCallback(() => {
    setConfirmation(false)
    closeModal()
  }, [closeModal])

  const handleRequestClose = useCallback(() => {
    if (isDirty) {
      setConfirmation(true)
    } else {
      handleInternalClose()
    }
  }, [isDirty, handleInternalClose])

  const acceptConfirmation = useCallback(() => {
    handleInternalClose()
  }, [handleInternalClose])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleRequestClose}
        classNames={{ modal: styles.modal }}
        showCloseIcon={false}
        closeOnEsc={!isDirty}
        closeOnOverlayClick={!isDirty}
        animationDuration={200}
        center
      >
        <div className={styles.modalMain}>
          <div className={styles.tabWrapper}>
            <div className={styles.inputsRow}>
              <Input
                label="Название"
                name="name"
                value={values.name}
                error={error('name')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <div style={{ padding: '15px' }}></div>
              <Input
                label="Выход (по умолчанию)"
                name="exit"
                value={values.exit}
                error={error('exit')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <div style={{ padding: '15px' }}></div>
              <Select
                value={values.edizm}
                error={error('edizm')}
                onChange={handleChange}
                name="edizm"
              >
                <option value="">Выберите</option>
                <option value="гр">гр</option>
                <option value="шт">шт</option>
              </Select>
            </div>

            <div className={styles.inputsRow}>
              <Input
                label="Калорийность (ккал)"
                name="kcal"
                value={values.kcal}
                error={error('kcal')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <div style={{ padding: '15px' }}></div>
              <Select
                label="Тип блюда"
                value={values.c_dishclass}
                error={error('c_dishclass')}
                onChange={handleChange}
                style={{ width: '300px' }}
                name="c_dishclass"
              >
                <option value="">Выберите</option>
                {dishTypeList?.map(({ name, c_dishclass }) => (
                  <option key={c_dishclass} value={c_dishclass}>{name}</option>
                ))}
              </Select>
            </div>

            <div className={styles.inputsRow}>
              <Input
                label="Цена"
                name="price"
                value={values.price}
                error={error('price')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
            </div>

            <br />

            <div className={styles.inputsRow} style={{ alignItems: 'flex-start' }}>
              <div className={styles.inputsColumn}>
                {dishTypeList?.map(par => {
                  const che = parallels?.find(el => +par.c_dishclass === +el)
                  return (
                    <Checkbox
                      key={par.c_dishclass}
                      label={par.name}
                      checked={!!che}
                      value={par.c_dishclass}
                      onChange={handleChangeCheck}
                      name="parallels"
                    />
                  )
                })}
              </div>

              <div className={styles.buttons_wrap}>
                <div className={styles.buttons}>
                  <>
                    <Button onClick={handlePick}>{image ? 'Изменить фото' : 'Загрузить фото'}</Button>
                    <input
                      className={styles.hidden}
                      type="file"
                      onChange={handleChangeFile}
                      accept="image/*"
                      id="filePicker"
                    />
                  </>
                </div>
                <br />
                {!!image && (
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Изображение блюда"
                    height={350}
                    width={450}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={handleInternalClose} />
      </Modal>

      {confirmation && (
        <Confirmation
          title="Есть несохраненные данные. Уверены что хотите выйти?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </>
  )
}
